module.exports = __webpack_public_path__ + "static/img/fgy.1cbcc10.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fgy.png
// module id = 3kys
// module chunks = 2